import { getMakeAPI, Method } from '@golden/gdk-base';
const makeAPI = getMakeAPI('admin/v1');
const makeOtherAPI = getMakeAPI('v1');
const AUTH_API = {
    ADMIN_LOGIN: makeAPI(Method.POST, 'login')(),
    ADMIN_STATUS: makeAPI(Method.GET, 'status')(),
    ADMIN_LOGOUT: makeAPI(Method.POST, 'logout')(),
    GET_ISSUE_AUTHENTICATOR: makeAPI(Method.GET, 'authenticator/issue')(),
    POST_VALIDATE_AUTHENTICATOR: makeAPI(Method.POST, 'authenticator/validate')(),
    DELETE_AUTHENTICATOR: makeAPI(Method.DELETE, 'admins/{id}/authenticator')()
};
const ME_API = {
    GET_ME: makeAPI(Method.GET, 'me')(),
    PUT_ADMIN_PASSWORD: makeAPI(Method.PUT, 'me')(),
    POST_PER_PAGE: makeOtherAPI(Method.POST, 'per-page')()
};
const ADMIN_ACCOUNT_API = {
    GET_ADMIN_LIST: makeAPI(Method.GET, 'admins')(),
    POST_ADMIN: makeAPI(Method.POST, 'admins')(),
    GET_ADMIN: makeAPI(Method.GET, 'admins/{id}')(),
    PUT_ADMIN: makeAPI(Method.PUT, 'admins/{id}')(),
    DELETE_ADMIN: makeAPI(Method.DELETE, 'admins/{id}')(),
    GET_VALIDATE_ADMIN_NICKNANE: makeAPI(Method.GET, 'validateNickname')(),
    GET_VALIDATE_ADMIN_ACCOUNT: makeAPI(Method.GET, 'validateAccount')()
};
const ANNOUNCEMENT_API = {
    GET_ANNOUNCEMENT: makeAPI(Method.GET, 'announcements/{id}')(),
    GET_ANNOUNCEMENT_LIST: makeAPI(Method.GET, 'announcements')(),
    GET_AGENT_ANNOUNCEMENT_LIST: makeAPI(Method.GET, 'staff-announcements')(),
    POST_NEW_ANNOUNCEMENT: makeAPI(Method.POST, 'announcements')(),
    PUT_CHANGE_ANNOUNCEMENT: makeAPI(Method.PUT, 'announcements/{id}')(),
    DELETE_ANNOUNCEMENT: makeAPI(Method.DELETE, 'announcements/{id}')(),
    PUT_TOGGLE_ANNOUNCEMENT_STATUS: makeAPI(Method.PUT, 'announcements/{id}/status')(),
    PUT_TOGGLE_AGENT_ANNOUNCEMENT_STATUS: makeAPI(Method.PUT, 'staff-announcements/{staffAnnouncement}')()
};
const NOTIFICATION_API = {
    GET_SYSTEM_NOTIFICATION_LIST: makeAPI(Method.GET, 'notification-system')(),
    GET_SYSTEM_NOTIFCATION: makeAPI(Method.GET, 'notification-system/{id}')(),
    PUT_SYSTEM_NOTIFICATION: makeAPI(Method.PUT, 'notification-system/{id}')(),
    GET_ANNNOUNCEMENT_PERSONAL_LIST: makeAPI(Method.GET, 'manual-notification')(),
    POST_ANNOUNCEMENT_PERSONAL: makeAPI(Method.POST, 'manual-notification')(),
    GET_ANNOUNCEMENT_PERSONAL_TEMPLATE_LIST: makeAPI(Method.GET, 'manual-notification-templates')(),
    POST_ANNOUNCEMENT_PERSONAL_TEMPLATE: makeAPI(Method.POST, 'manual-notification-templates')(),
    GET_ANNOUNCEMENT_PERSONAL_TEMPLATE: makeAPI(Method.GET, 'manual-notification-templates/{id}')(),
    PUT_ANNOUNCEMENT_PERSONAL_TEMPLATE: makeAPI(Method.PUT, 'manual-notification-templates/{id}')(),
    DELETE_ANNOUNCEMENT_PERSONAL_TEMPLATE: makeAPI(Method.DELETE, 'manual-notification-templates/{id}')(),
    POST_ANNOUNCEMENT_PERSONAL_VALIDATE_AGENT_ACCOUNT: makeAPI(Method.POST, 'manual-notification/validate-agent')(),
    GET_ANNOUNCEMENT_PERSONAL_USER_LIST: makeAPI(Method.GET, 'manual-notification/{id}/users')(),
    GET_ANNOUNCEMENT_PERSONAL_QUEUES: makeAPI(Method.GET, 'manual-notification-queues')(),
    DELETE_ANNOUNCEMENT_PERSONAL_QUEUES: makeAPI(Method.DELETE, 'manual-notification-queues/{id}')(),
    GET_BANNER_NOTIFICATIONS: makeAPI(Method.GET, 'banner-notifications')(),
    POST_BANNER_NOTIFICATION: makeAPI(Method.POST, 'banner-notifications')(),
    POST_BANNER_NOTIFICATION_USER_INFO_CSV: makeAPI(Method.POST, '/banner-notifications/user-info-csv')(),
    GET_BANNER_NOTIFICATION_DETAIL: makeAPI(Method.GET, 'banner-notifications/{id}')(),
    GET_BANNER_NOTIFICATION_RECEIVER_LIST: makeAPI(Method.GET, 'banner-notifications/{id}/users')(),
    POST_BANNER_NOTIFICATION_VALIDATE_AGENT_ACCOUNT: makeAPI(Method.POST, 'banner-notifications/validate-agent')(),
    DELETE_BANNER_NOTIFICATION: makeAPI(Method.DELETE, 'banner-notifications/{id}')(),
    PUT_TOGGLE_BANNER_NOTIFICATION_STATUS: makeAPI(Method.PUT, 'banner-notifications/{id}/active')()
};
const SMS_API = {
    GET_SMS_PROVIDER_LIST: makeAPI(Method.GET, 'sms-providers')(),
    PUT_SMS_PROVIDER: makeAPI(Method.PUT, 'sms-providers')(),
    GET_SMS_HISTORY: makeAPI(Method.GET, 'sms-logs')(),
    POST_RESEND_SMS: makeAPI(Method.POST, 'sms/{id}/resend')()
};
const ROLE_API = {
    GET_ROLE_TREE: makeAPI(Method.GET, 'hierarchy/roles-tree')(),
    GET_ROLE_LIST: makeAPI(Method.GET, 'hierarchy/roles')(),
    POST_ROLE: makeAPI(Method.POST, 'hierarchy/roles')(),
    GET_ROLE: makeAPI(Method.GET, 'hierarchy/roles/{id}')(),
    PUT_ROLE: makeAPI(Method.PUT, 'hierarchy/roles/{id}')(),
    DEL_ROLE: makeAPI(Method.DELETE, 'hierarchy/roles/{id}')()
};
const EMPEROR_API = {
    GET_SUGGEST_ACCOUNT: makeAPI(Method.GET, 'emperors/available')(),
    GET_EMPEROR_LIST: makeAPI(Method.GET, 'emperors')(),
    POST_NEW_EMPEROR: makeAPI(Method.POST, 'emperors')(),
    GET_EMPEROR: makeAPI(Method.GET, 'emperors/info/{id}')(),
    GET_EMPEROR_FEES: makeAPI(Method.GET, 'emperors/deposit-withdraw-fees')(),
    PUT_CHANGE_EMPEROR: makeAPI(Method.PUT, 'emperors/{id}')(),
    GET_LAYER: makeAPI(Method.GET, 'emperors/{id}/layer')(),
    GET_LAYER_INFO: makeAPI(Method.GET, 'emperors/{id}/layer/info')(),
    GET_LAYER_INFO_CHILDREN: makeAPI(Method.GET, 'emperors/{id}/layer/info/children')(),
    PUT_AGENT: makeAPI(Method.PUT, 'agents/{id}/loginable')()
};
const AGENT_WALLETS_API = {
    GET_AGENT_WALLETS_HISTORY: makeAPI(Method.GET, 'agent-wallets/history')(),
    GET_AGENT_WALLETS_SUMMARY: makeAPI(Method.GET, 'agent-wallets/summary')(),
    POST_AGENT_WALLETS_RECHARGE: makeAPI(Method.POST, 'agent-wallets/recharge')(),
    POST_AGENT_WALLETS_REVOKE: makeAPI(Method.POST, 'agent-wallets/revoke')(),
    POST_AGENT_WALLETS_TOP_UP: makeAPI(Method.POST, 'agent-wallets/top-up')(),
    POST_AGENT_WALLETS_DEDUCT: makeAPI(Method.POST, 'agent-wallets/deduct')(),
    POST_AGENT_WALLETS_MANUAL_DEPOSIT: makeAPI(Method.POST, 'agent-wallets/manual-deposit')()
};
const STAFF_API = {
    GET_STAFF_LIST: makeAPI(Method.GET, 'staffs')()
};
const JUMP_SHIP_API = {
    POST_VALIDATE_STAFF_ACCOUNT: makeAPI(Method.POST, 'player/jump-ship/exist-staff-account')(),
    POST_VALIDATE_JUMP_SHIP: makeAPI(Method.POST, 'player/jump-ship/validation')(),
    POST_PLAYER_JUMP_SHIP: makeAPI(Method.POST, 'player/jump-ship')(),
    GET_PLAYER_JUMP_SHIP_RECORD: makeAPI(Method.GET, 'player/jump-ship/record')(),
    DELETE_PLAYER_JUMP_SHIP: makeAPI(Method.DELETE, 'player/jump-ship/{id}')()
};
const PLAYER_API = {
    GET_PLAYER_LIST: makeAPI(Method.GET, 'players/management-list')(),
    GET_PLAYER_CENTER: makeAPI(Method.GET, 'players/{id}/center')(),
    PUT_PLAYER_CENTER: makeAPI(Method.PUT, 'players/{id}/center')(),
    GET_PLAYER_WITHDRAWAL_ACCOUNTS: makeAPI(Method.GET, 'players/{id}/withdrawal-accounts')(),
    POST_PLAYER_WITHDRAWAL_ACCOUNT: makeAPI(Method.POST, 'players/{id}/withdrawal-accounts')(),
    DELETE_PLAYER_WITHDRAWAL_ACCOUNTS: makeAPI(Method.DELETE, 'players/{id}/withdrawal-accounts/{accountId}')(),
    GET_PLAYER_DEBIT_CARDS: makeAPI(Method.GET, 'players/{id}/debit-cards')(),
    VALIDATE_PLAYER_DEBIT_CARD: makeAPI(Method.POST, 'players/validate-bank-account')(),
    POST_PLAYER_DEBIT_CARDS: makeAPI(Method.POST, 'players/{id}/debit-cards')(),
    PUT_PLAYER_DEBIT_CARDS: makeAPI(Method.PUT, 'players/{id}/debit-cards/{cardId}')(),
    DELETE_PLAYER_DEBIT_CARDS: makeAPI(Method.DELETE, 'players/{id}/debit-cards/{cardId}')(),
    GET_PLAYER_CRYPTO_WALLETS: makeAPI(Method.GET, 'players/{id}/crypto-wallets')(),
    DELETE_PLAYER_CRYPTO_WALLETS: makeAPI(Method.DELETE, 'players/{id}/crypto-wallets/{walletId}')(),
    POST_PLAYER_DEBIT_CARDS_BLACKLIST: makeAPI(Method.POST, 'players/{id}/debit-cards/{cardId}/blacklist')(),
    GET_PLAYER_GAME_STATUS: makeAPI(Method.GET, 'players/{id}/game-status')(),
    GET_PLAYER_INFO: makeAPI(Method.GET, 'players/{id}/info')(),
    POST_PLAYER_NICKNAME: makeAPI(Method.POST, 'players/{id}/info/nickname')(),
    POST_PLAYER_PHONE: makeAPI(Method.POST, 'players/{id}/info/phone')(),
    POST_PLAYER_PHONE_VALIDATE: makeAPI(Method.POST, 'players/{id}/info/phone/validate')(),
    POST_PLAYER_EMAIL: makeAPI(Method.POST, 'players/{id}/info/email')(),
    POST_PLAYER_INFO_MEMO: makeAPI(Method.POST, 'players/{id}/info/memo')(),
    GET_PLAYER_SETTING: makeAPI(Method.GET, 'players/{id}/setting')(),
    PUT_PLAYER_SETTING: makeAPI(Method.PUT, 'players/{id}/setting')(),
    GET_PLAYER_GOUBAO: makeAPI(Method.GET, 'players/{id}/goubao')(),
    GET_PLAYER_TRANSACTIONS: makeAPI(Method.GET, 'players/{id}/transactions')(),
    GET_PLAYER_BET_HSITROY_STATISTIC: makeAPI(Method.GET, 'players/{id}/bet-history-statistic')(),
    GET_PLAYER_CASH_LOG_STATISTIC: makeAPI(Method.GET, 'players/{id}/cash-log-statistic')(),
    GET_PLAYER_RANK_LIST: makeAPI(Method.GET, 'player/ranks/withdraw-parameters')(),
    GET_PLAYER_RANK: makeAPI(Method.GET, 'player/ranks/withdraw-parameters/{id}')(),
    PUT_PLAYER_RANK: makeAPI(Method.PUT, 'player/ranks/withdraw-parameters/{id}')(),
    GET_PLAYER_RANK_USER: makeAPI(Method.GET, 'player/ranks/user')(),
    PUT_PLAYER_RANK_USER: makeAPI(Method.PUT, 'player/ranks/user/{id}')(),
    GET_PLAYER_RANK_ACTIVITY: makeAPI(Method.GET, 'player/ranks/detail')(),
    POST_ELEMENT_FOUR: makeAPI(Method.POST, 'element/four')(),
    GET_PLAYER_LAYER_LIST: makeAPI(Method.GET, 'layers')(),
    GET_PLAYER_LAYER_SIMPLE_LIST: makeAPI(Method.GET, 'layers/short-list')(),
    GET_PLAYER_LAYER: makeAPI(Method.GET, 'layers/{id}')(),
    PUT_PLAYER_LAYER: makeAPI(Method.PUT, 'layers/{id}')(),
    GET_PLAYER_LAYER_SEARCH: makeAPI(Method.GET, 'layers/search-players')(),
    POST_LOCKED_PLAYERS: makeAPI(Method.POST, 'layers/lock-players')(),
    POST_UNLOCKED_PLAYERS: makeAPI(Method.POST, 'layers/unlock-players')(),
    POST_LAYER_STRATIFY_LAYER: makeAPI(Method.POST, 'layers/stratify-layer')(),
    POST_LAYER_RESET_LAYER_START_AT: makeAPI(Method.POST, 'layers/reset-layer-start-at')(),
    POST_SEARCH_PLAYER: makeOtherAPI(Method.POST, 'search/player')(),
    GET_PLAYER_RANK_EFFECTIVE_BETS: makeAPI(Method.GET, '/player/rank-effective-bets')(),
    GET_PLAYER_RANK_LOG: makeAPI(Method.GET, '/player/ranks/logs')(),
    POST_PLAYER_RANK_EFFECTIVE_BETS: makeAPI(Method.POST, '/player/rank-effective-bets/{id}')(),
    POST_PLAYER_RANK_EFFECTIVE_BETS_REVOKE: makeAPI(Method.POST, '/player/rank-effective-bets/{id}/revoke')(),
    GET_PLAYER_OPERATION_LOGS: makeAPI(Method.GET, 'players/operation-logs')(),
    GET_PLAYER_CGPay_Detail: makeAPI(Method.GET, 'players/{user}/cgpay')(),
    GET_PLAYER_RELATIONS: makeAPI(Method.GET, 'players/{user}/relations')(),
    POST_PLAYER_RELATIONS: makeAPI(Method.POST, 'players/{user}/relations')(),
    PUT_PLAYER_RELATIONS: makeAPI(Method.PUT, '/players/{user}/relations/{relation}')(),
    DELETE_PLAYER_RELATIONS: makeAPI(Method.DELETE, '/players/{user}/relations/{relation}')()
};
const FINANCE_API = {
    GET_FINANCE_ALERT: makeAPI(Method.GET, 'finance/alert')(),
    GET_FINANCE_DEBIT_CARD_BLACKLIST: makeAPI(Method.GET, 'finance/blacklist')(),
    POST_VALIDATE_BLACKLIST_DEBIT_CARD: makeAPI(Method.POST, 'finance/blacklist/validate-bank-account')(),
    POST_FINANCE_BLACKLIST: makeAPI(Method.POST, 'finance/blacklist')(),
    DELETE_FINANCE_BLACKLIST: makeAPI(Method.DELETE, 'finance/blacklist/{id}')(),
    GET_ACCOUNT_NUMBER_INFO: makeAPI(Method.POST, 'finance/blacklist/debit-card-info')(),
    GET_FINANCE_COURIER_LIST: makeAPI(Method.GET, 'finance/forwarders')(),
    GET_FINANCE_COURIER: makeAPI(Method.GET, 'finance/forwarders/{id}')(),
    POST_FINANCE_COURIER: makeAPI(Method.POST, 'finance/forwarders')(),
    PUT_FINANCE_COURIER: makeAPI(Method.PUT, 'finance/forwarders/{id}')(),
    GET_FINANCE_ACTIVE_FORWARDERS: makeAPI(Method.GET, 'finance/forwarders/active')(),
    GET_FINANCE_COURIERS_METHODS: makeAPI(Method.GET, 'finance/forwarders/methods')(),
    GET_FINANCE_FORWARDER_CONFIG: makeAPI(Method.GET, 'finance/forwarder-config')(),
    GET_FINANCE_DEPOSIT_WAY_GROUPS_LIST: makeAPI(Method.GET, 'finance/deposit/way-groups')(),
    GET_FINANCE_DEPOSIT_WAY_GROUP: makeAPI(Method.GET, 'finance/deposit/way-groups/{id}')(),
    POST_FINANCE_DEPOSIT_WAY_GROUP: makeAPI(Method.POST, 'finance/deposit/way-groups')(),
    PUT_FINANCE_DEPOSIT_WAY_GROUP: makeAPI(Method.PUT, 'finance/deposit/way-groups/{id}')(),
    DELETE_FINANCE_DEPOSIT_WAY_GROUP: makeAPI(Method.DELETE, 'finance/deposit/way-groups/{id}')(),
    GET_FINANCE_DEPOSIT_WAY_GROUPS_SEARCH: makeAPI(Method.GET, 'finance/deposit/way-groups/search')(),
    GET_DEPOSIT_WAY_LIST: makeAPI(Method.GET, 'finance/deposit/ways')(),
    POST_DEPOSIT_WAY: makeAPI(Method.POST, 'finance/deposit/ways')(),
    GET_DEPOSIT_WAY: makeAPI(Method.GET, 'finance/deposit/ways/{id}')(),
    PUT_DEPOSIT_WAY: makeAPI(Method.PUT, 'finance/deposit/ways/{id}')(),
    DELETE_DEPOSIT_WAY: makeAPI(Method.DELETE, 'finance/deposit/ways/{id}')(),
    GET_DEPOSIT_WAY_METHOD_GROUPS: makeAPI(Method.GET, 'finance/deposit/ways/method-groups')(),
    GET_DEPOSIT_METHOD_PRIORITIES: makeAPI(Method.GET, 'finance/deposit/ways/method-priorities')(),
    PUT_DEPOSIT_METHOD_PRIORITIES: makeAPI(Method.PUT, 'finance/deposit/ways/method-priorities')(),
    GET_WITHDRAWAL_METHOD_PRIORITIES: makeAPI(Method.GET, 'finance/withdraw/ways/method-priorities')(),
    PUT_WITHDRAWAL_METHOD_PRIORITIES: makeAPI(Method.PUT, 'finance/withdraw/ways/method-priorities')(),
    GET_WITHDRAWAL_WAY_LIST: makeAPI(Method.GET, 'finance/withdraw/ways')(),
    GET_WITHDRAWAL_WAY: makeAPI(Method.GET, 'finance/withdraw/ways/{id}')(),
    POST_WITHDRAWAL_WAY: makeAPI(Method.POST, 'finance/withdraw/ways')(),
    PUT_WITHDRAWAL_WAY: makeAPI(Method.PUT, 'finance/withdraw/ways/{id}')(),
    DELETE_WITHDRAWAL_WAY: makeAPI(Method.DELETE, 'finance/withdraw/ways/{id}')(),
    GET_SUPPORT_BANK: makeOtherAPI(Method.GET, 'bank-codes')(),
    GET_BANK_LIST: makeAPI(Method.GET, 'finance/banks')(),
    GET_BANK: makeAPI(Method.GET, 'finance/banks/{id}')(),
    PUT_BANK: makeAPI(Method.PUT, 'finance/banks/{id}')(),
    PUT_BANK_MAINTAIN: makeAPI(Method.PUT, 'finance/banks/{id}/maintain')(),
    GET_FINANCE_FEE_LIST: makeAPI(Method.GET, 'finance/parameter/withdraw')(),
    GET_FINANCE_FEE: makeAPI(Method.GET, 'finance/parameter/withdraw/{id}')(),
    PUT_FINANCE_FEE: makeAPI(Method.PUT, 'finance/parameter/withdraw/{id}')(),
    GET_PIGGY_BANK_LIST: makeAPI(Method.GET, 'finance/piggy-bank')(),
    POST_PIGGY_BANK: makeAPI(Method.POST, 'finance/piggy-bank')(),
    GET_PIGGY_BANK_BANK_OPTIONS: makeAPI(Method.GET, 'finance/piggy-bank/banks')(),
    GET_PIGGY_BANK: makeAPI(Method.GET, 'finance/piggy-bank/{id}')(),
    PUT_PIGGY_BANK: makeAPI(Method.PUT, 'finance/piggy-bank/{id}')(),
    PUT_PIGGY_BANK_ACTIVE: makeAPI(Method.PUT, 'finance/piggy-bank/{id}/active')(),
    DELETE_PIGGY_BANK: makeAPI(Method.DELETE, 'finance/piggy-bank/{id}')(),
    GET_PIGGY_WECHAT_LIST: makeAPI(Method.GET, 'finance/piggy-wechat')(),
    POST_PIGGY_WECHAT: makeAPI(Method.POST, 'finance/piggy-wechat')(),
    GET_PIGGY_WECHAT: makeAPI(Method.GET, 'finance/piggy-wechat/{id}')(),
    PUT_PIGGY_WECHAT: makeAPI(Method.PUT, 'finance/piggy-wechat/{id}')(),
    PUT_PIGGY_WECHAT_ACTIVE: makeAPI(Method.PUT, 'finance/piggy-wechat/{id}/active')(),
    DELETE_PIGGY_WECHAT: makeAPI(Method.DELETE, 'finance/piggy=wechat/{id}')(),
    GET_PIGGY_ALIPAY_LIST: makeAPI(Method.GET, 'finance/piggy-alipay')(),
    POST_PIGGY_ALIPAY: makeAPI(Method.POST, 'finance/piggy-alipay')(),
    GET_PIGGY_ALIPAY: makeAPI(Method.GET, 'finance/piggy-alipay/{id}')(),
    PUT_PIGGY_ALIPAY: makeAPI(Method.PUT, 'finance/piggy-alipay/{id}')(),
    PUT_PIGGY_ALIPAY_ACTIVE: makeAPI(Method.PUT, 'finance/piggy-alipay/{id}/active')(),
    DELETE_PIGGY_ALIPAY: makeAPI(Method.DELETE, 'finance/piggy-alipay/{id}')(),
    GET_EXCHANGE_RATE_DEFAULT: makeAPI(Method.GET, 'finance/exchange-rate/default')(),
    POST_EXCHANGE_RATE_DEFAULT: makeAPI(Method.POST, 'finance/exchange-rate/default')(),
    GET_EXCHANGE_RATE_DIFF: makeAPI(Method.GET, 'finance/exchange-rate/diff')(),
    POST_EXCHANGE_RATE_DIFF: makeAPI(Method.POST, 'finance/exchange-rate/diff')(),
    GET_EXCHANGE_RATE_PROVIDER: makeAPI(Method.GET, 'finance/exchange-rate/providers')(),
    PUT_EXCHANGE_RATE_PROVIDER: makeAPI(Method.PUT, 'finance/exchange-rate/providers')(),
    GET_BANKS_MAPPING_FORWARDER_LIST: makeAPI(Method.GET, 'finance/banks-mapping/forwarder-list')(),
    GET_BANKS_MAPPING_FORWARDER: makeAPI(Method.GET, 'finance/banks-mapping/{slug}')(),
    PUT_BANKS_MAPPING_FORWARDER: makeAPI(Method.PUT, 'finance/banks-mapping/{slug}')(),
    GET_DEPOSIT_FEE_METHOD: makeAPI(Method.GET, 'finance/deposit/ways/has-fee-method')(),
    GET_DEPOSIT_QUERY_LIST: makeAPI(Method.GET, 'finance/deposit/ways/query-list')(),
    GET_WITHDRAW_FEE_METHOD: makeAPI(Method.GET, 'finance/withdraw/ways/has-fee-method')(),
    GET_WITHDRAW_QUERY_LIST: makeAPI(Method.GET, 'finance/withdraw/ways/query-list')(),
    GET_FINANCE_WITHDRAWAL_ACCOUNT_BLACKLIST: makeAPI(Method.GET, 'user-withdrawal-accounts/blacklist')(),
    POST_FINANCE_WITHDRAWAL_ACCOUNT_BLACKLIST: makeAPI(Method.POST, 'user-withdrawal-accounts/{id}/blacklist')(),
    DELETE_FINANCE_WITHDRAWAL_ACCOUNT_BLACKLIST: makeAPI(Method.DELETE, 'user-withdrawal-accounts/blacklist/{id}')(),
    VALIDATE_PLAYER_WITHDRAWAL_ACCOUNT: makeAPI(Method.POST, 'user-withdrawal-accounts/validate-withdrawal-account')()
};
const DEPOSIT_API = {
    GET_DEPOSIT_SLIP_LIST: makeAPI(Method.GET, 'finance/golden/deposit-manage')(),
    GET_DEPOSIT_BANK_SIMPLE_LIST: makeAPI(Method.GET, 'finance/golden/deposit-manage/banks')(),
    POST_DEPOSIT_SLIP_STATUS: makeAPI(Method.POST, 'finance/golden/deposit-manage/{id}/confirm')(),
    GET_THIRD_PARTY_DEPOSIT_SLIP_SUMMARY: makeAPI(Method.GET, 'finance/third-party/deposit-manage/summary')(),
    GET_THIRD_PARTY_DEPOSIT_SLIP_PLAYER_LIST: makeAPI(Method.GET, 'finance/third-party/deposit-manage')(),
    GET_THIRD_PARTY_DEPOSIT_SLIP_AGENT_LIST: makeAPI(Method.GET, 'finance/third-party/deposit-manage/agents')(),
    GET_THIRD_PARTY_DEPOSIT_COURIER_SIMPLE_LIST: makeAPI(Method.GET, 'finance/third-party/deposit-manage/forwarders')(),
    POST_THIRD_PARTY_DEPOSIT_SLIP_STATUS_PLAYER: makeAPI(Method.POST, 'finance/third-party/deposit-manage/{id}/confirm')(),
    POST_THIRD_PARTY_DEPOSIT_SLIP_STATUS_AGENT: makeAPI(Method.POST, 'finance/third-party/deposit-manage/agents/{id}/confirm')(),
    GET_DEPOSIT_ERROR: makeAPI(Method.GET, 'finance/deposit-error')(),
    POST_BARRIERS_DETECT: makeAPI(Method.POST, 'withdraw-barriers/detect')()
};
const WITHDRAW_API = {
    GET_WITHDRAW_COURIER_LIST: makeAPI(Method.GET, 'withdraw-manage/forwarders')(),
    // FM
    GET_WITHDRAW_SLIP_LIST: makeAPI(Method.GET, 'withdraw-manage')(),
    GET_WITHDRAW_SLIP_DETAIL: makeAPI(Method.GET, 'withdraw-manage/{id}')(),
    POST_WITHDRAW_SLIP_REVIEW: makeAPI(Method.POST, 'withdraw-manage/{id}/lock')(),
    POST_WITHDRAW_SLIP_UNLOCK: makeAPI(Method.POST, 'withdraw-manage/{id}/unlock')(),
    GET_WITHDRAW_SLIP_ACCOUNTING: makeAPI(Method.GET, 'withdraw-manage/{id}/accounting')(),
    GET_WITHDRAW_SLIP_TRANSFER: makeAPI(Method.GET, 'withdraw-manage/{id}/transfer-logs')(),
    GET_WITHDRAW_SLIP_COURIER: makeAPI(Method.GET, 'withdraw-manage/{id}/forwarders')(),
    GET_WITHDRAW_SLIP_EXCHANGE_RATE: makeAPI(Method.GET, 'withdraw-manage/{id}/exchange-rate')(),
    POST_WITHDRAW_SLIP_TO_GOLDEN: makeAPI(Method.POST, 'withdraw-manage/{id}/golden')(),
    POST_WITHDRAW_SLIP_TO_THIRD_PARTY: makeAPI(Method.POST, 'withdraw-manage/{id}/third-party')(),
    POST_WITHDRAW_SLIP_CANCEL: makeAPI(Method.POST, 'withdraw-manage/{id}/cancel')(),
    POST_WITHDRAW_SLIP_STOP_THIRD_PARTY: makeAPI(Method.POST, 'withdraw-manage/{id}/third-party/cancel')(),
    // RC
    GET_WITHDRAW_SLIP_RC_LIST: makeAPI(Method.GET, 'withdraw-manage/rc')(),
    GET_WITHDRAW_SLIP_RC_DETAIL: makeAPI(Method.GET, 'withdraw-manage/rc/{id}')(),
    POST_WITHDRAW_SLIP_RC_REVIEW: makeAPI(Method.POST, 'withdraw-manage/rc/{id}/lock')(),
    POST_WITHDRAW_SLIP_RC_UNLOCK: makeAPI(Method.POST, 'withdraw-manage/rc/{id}/unlock')(),
    POST_WITHDRAW_SLIP_RC_APPLY: makeAPI(Method.POST, 'withdraw-manage/rc/{id}/apply')(),
    GET_AUTO_WITHDRAW: makeAPI(Method.GET, 'withdraw-limit/auto')(),
    PUT_AUTO_WITHDRAW: makeAPI(Method.POST, 'withdraw-limit/auto')(),
    GET_WITHDRAW_LIMIT_LIST: makeAPI(Method.GET, 'withdraw-limit/player')(),
    GET_WITHDRAW_LIMIT: makeAPI(Method.GET, 'withdraw-limit/player/{id}')(),
    POST_WITHDRAW_LIMIT: makeAPI(Method.POST, 'withdraw-limit/player')(),
    PUT_WITHDRAW_LIMIT: makeAPI(Method.PUT, 'withdraw-limit/player/{id}')(),
    DELETE_WITHDRAW_LIMIT: makeAPI(Method.DELETE, 'withdraw-limit/player/{id}')(),
    GET_WITHDRAW_TIP: makeAPI(Method.GET, 'withdraw-tips')(),
    POST_WITHDRAW_TIP: makeAPI(Method.POST, 'withdraw-tips')(),
    GET_WITHDRAW_FEES: makeAPI(Method.GET, 'withdraw-fees')(),
    POST_WITHDRAW_FEES: makeAPI(Method.POST, 'withdraw-fees')(),
    GET_WALLETS: makeAPI(Method.GET, 'wallets')(),
    POST_WALLET_TRANSFER: makeAPI(Method.POST, 'wallets/transfer')(),
    POST_WALLET_DUMP: makeAPI(Method.POST, 'wallets/transfer/dump')(),
    GET_EFFECTIVE_CASH: makeAPI(Method.GET, 'withdraw-barriers/user-info')(),
    POST_EFFECTIVE_CASH: makeAPI(Method.POST, 'withdraw-barriers')(),
    GET_EFFECTIVE_CASH_HISTORY: makeAPI(Method.GET, 'withdraw-barriers')(),
    GET_BARRIERS_PREVIEW: makeAPI(Method.GET, 'withdraw-barriers/preview')(),
    GET_WITHDRAW_BARRIER_STEP_BY_STEP: makeAPI(Method.GET, 'withdraw-barriers/step-by-step')()
};
const PARAMETER_API = {
    POST_EXPORT_FINANCE: makeAPI(Method.POST, 'finance/export-finance')(),
    GET_ISSUE_PARAMETER_AUTHENTICATOR: makeAPI(Method.GET, 'parameters/authenticator/issue')(),
    POST_VALIDATE_PARAMETER_AUTHENTICATOR: makeAPI(Method.POST, 'parameters/authenticator/validate')(),
    POST_DELETE_PARAMETER_AUTHENTICATOR: makeAPI(Method.POST, 'parameters/authenticator/delete')(),
    GET_PARAMETER_AUTHENTICATOR_STATUS: makeAPI(Method.GET, 'parameters/authenticator/status')(),
    GET_IP_WHITELIST_LIST: makeAPI(Method.GET, 'ip-whitelists')(),
    POST_IP_WHITELIST: makeAPI(Method.POST, 'ip-whitelists')(),
    DELETE_IP_WHITELIST: makeAPI(Method.DELETE, 'ip-whitelists/{id}')(),
    GET_DOMAIN_LIST: makeAPI(Method.GET, 'domains')(),
    PUT_DOMAIN: makeAPI(Method.PUT, 'domains')(),
    GET_PROMO_DOMAIN_LIST: makeAPI(Method.GET, 'promo-domains')(),
    PUT_PROMO_DOMAIN: makeAPI(Method.PUT, 'promo-domains')()
};
const MANUAL_API = {
    GET_MANUAL_WITHDRAW_LIST: makeAPI(Method.GET, 'manual/withdraw')(),
    POST_MANUAL_WITHDRAW: makeAPI(Method.POST, 'manual/withdraw')(),
    GET_MANUAL_EFFECTIVE_BET: makeAPI(Method.GET, 'manual/bet')(),
    GET_MANUAL_DEPOSIT_LIST: makeAPI(Method.GET, 'manual/deposit')(),
    GET_MANUAL_DEPOSIT_PROCESS: makeAPI(Method.GET, 'manual/deposit-process')(),
    GET_MANUAL_DEPOSIT_UPDATE_SERIAL_NUMBER: makeAPI(Method.GET, 'manual/deposit/update/serial-number')(),
    GET_MANUAL_DEPOSIT_UPDATE_BATCH_ID: makeAPI(Method.GET, 'manual/deposit/update/batch-id')(),
    DELETE_MANUAL_DEPOSIT_PROCESS: makeAPI(Method.DELETE, 'manual/deposit-process/{id}')(),
    POST_MANUAL_DEPOSIT_PROCESS_RETRY: makeAPI(Method.POST, 'manual/deposit-process/retry/{id}')(),
    POST_MANUAL_DEPOSIT: makeAPI(Method.POST, 'manual/deposit')(),
    PUT_MANUAL_DEPOSIT_BINDING_DEPOSITS: makeAPI(Method.PUT, 'manual/deposit/{id}')(),
    POST_MANUAL_DEPOSIT_CSV: makeAPI(Method.POST, 'manual/deposit-csv')(),
    POST_WITHDRAW_BARRIERS_USER_INFO_CSV: makeAPI(Method.POST, 'withdraw-barriers/user-info-csv')(),
    POST_MANUAL_WITHDRAW_CSV: makeAPI(Method.POST, 'manual/withdraw-csv')(),
    POST_WITHDRAW_BARRIERS_USER_INFO_WITHDRAW_CSV: makeAPI(Method.POST, 'withdraw-barriers/user-info-withdraw-csv')(),
    PUT_MANUAL_DEPOSIT_UPDATE_SERIAL_NUMBER: makeAPI(Method.PUT, 'manual/deposit/update/serial-number')(),
    PUT_MANUAL_DEPOSIT_UPDATE_BATCH_ID: makeAPI(Method.PUT, 'manual/deposit/update/batch-id')()
};
const PLATFORM_API = {
    GET_PLATFORM: makeAPI(Method.GET, 'platforms')(),
    GET_EXCLUDE_GOLDEN_PLATFORM: makeAPI(Method.GET, 'platforms/exclude-golden')(),
    PUT_PLATFORM: makeAPI(Method.PUT, 'platforms')(),
    GET_GAME_LIST: makeAPI(Method.GET, 'games')(),
    GET_FEEDBACK_LIST: makeAPI(Method.GET, 'platform/feedback')(),
    GET_FEEDBACK: makeAPI(Method.GET, 'platform/feedback/{id}')(),
    PUT_FEEDBACK: makeAPI(Method.PUT, 'platform/feedback/{id}')(),
    GET_CHANNEL_LIST: makeAPI(Method.GET, 'channel-list/{id}')(),
    GET_FETCH_TASKS_LIST: makeAPI(Method.GET, 'fetch-tasks')(),
    POST_FETCH_TASK: makeAPI(Method.POST, 'fetch-tasks')(),
    POST_FETCH_BTI: makeAPI(Method.POST, 'fetch-bti')(),
    GET_PLATFORM_FEE: makeAPI(Method.GET, 'platform-fees/{game}')(),
    PUT_PLATFORM_FEE: makeAPI(Method.PUT, 'platform-fees/{game}')(),
    GET_PLATFORM_FEE_STATUS: makeOtherAPI(Method.GET, 'platform-fees/updated')(),
    GET_CHANNELS: makeAPI(Method.GET, 'games/{game}/channels', '20230717')(),
    POST_CHANNELS: makeAPI(Method.POST, 'games/{game}/channels')(),
    PUT_CHANNEL: makeAPI(Method.PUT, 'channels/{channel}')(),
    DELETE_CHANNEL: makeAPI(Method.DELETE, 'channels/{channel}')()
};
const GREETING_API = {
    GET_GREETING: makeAPI(Method.GET, 'greetings')(),
    GET_RANDOM_GREETING: makeAPI(Method.GET, 'greetings/random')(),
    POST_GREETING: makeAPI(Method.POST, 'greetings')(),
    PUT_GREETING: makeAPI(Method.PUT, 'greetings/{id}')(),
    DELETE_GREETING: makeAPI(Method.DELETE, 'greetings/{id}')()
};
const ALERT_API = {
    GET_ALERT_LIST: makeAPI(Method.GET, 'alerts')()
};
const ACTIVITY_API = {
    GET_ACTIVITY_LIST: makeAPI(Method.GET, 'activity-types')(),
    GET_ACTIVITY_MANAGEMENT_LIST: makeAPI(Method.GET, 'activities')(),
    GET_ACTIVITY_WALLET_LIST: makeAPI(Method.GET, 'activity/activity-wallet')(),
    GET_ACTIVITY_WALLET_USER_INFO: makeAPI(Method.GET, 'activity/activity-wallet/user-info')(),
    POST_ACTIVITY_WALLET_USER_INFO_CSV: makeAPI(Method.POST, 'activity/activity-wallet/user-info-csv')(),
    POST_ACTIVITY_WALLET_CREATE_CSV: makeAPI(Method.POST, 'activity/activity-wallet/create-csv')(),
    POST_ACTIVITY_WALLET_CREATE: makeAPI(Method.POST, 'activity/activity-wallet/create')(),
    GET_ACTIVITY_WALLET_CREATE_PROCESS: makeAPI(Method.GET, 'activity/activity-wallet/create-process')(),
    DELETE_ACTIVITY_WALLET_CREATE_PROCESS: makeAPI(Method.DELETE, 'activity/activity-wallet/create-process/{id}')(),
    GET_ACTIVITY_WALLET_ACTIVITY_TITLE: makeAPI(Method.GET, 'activity/activity-wallet/activity-title')(),
    POST_ACTIVITY_WALLET_ACTIVITY_TITLE: makeAPI(Method.POST, 'activity/activity-wallet/activity-title')(),
    PUT_ACTIVITY_WALLET_ACTIVITY_TITLE: makeAPI(Method.PUT, 'activity/activity-wallet/activity-title/{id}')(),
    DELETE_ACTIVITY_WALLET_ACTIVITY_TITLE: makeAPI(Method.DELETE, 'activity/activity-wallet/activity-title/{id}')(),
    POST_ACTIVITY_WALLET_ACTIVITY_TITLE_ORDER: makeAPI(Method.POST, 'activity/activity-wallet/activity-title/order')(),
    GET_ACTIVITY_WALLET_ACTIVITY_TITLE_STATS: makeAPI(Method.GET, 'activity/activity-wallet/activity-title/{id}/stats')(),
    PUT_ACTIVITY_WALLET_BINDING_DEPOSITS: makeAPI(Method.PUT, 'activity/activity-wallet/{id}')(),
    POST_ACTIVITY_WALLET_ACTIVITY_REVOKE: makeAPI(Method.POST, 'activity/activity-wallet/revoke')(),
    GET_ACTIVITY_OVERVIEW: makeAPI(Method.GET, 'activities/overview')(),
    GET_ACTIVITY_OVERVIEW_AGENT: makeAPI(Method.GET, 'activities/overview/agents/{id}/children')(),
    GET_ACTIVITY_OVERVIEW_GOLDEN: makeAPI(Method.GET, 'activities/overview/agents/golden/children')(),
    GET_ACTIVITY_PRIORITY: makeAPI(Method.GET, 'activities/priority')(),
    PUT_ACTIVITY_PRIORITY: makeAPI(Method.PUT, 'activities/priority')(),
    GET_ACTIVITY_TAGS_PRIORITY: makeAPI(Method.GET, 'activity/tags/priority')(),
    PUT_ACTIVITY_TAGS_PRIORITY: makeAPI(Method.PUT, 'activity/tags/priority')(),
    PUT_ACTIVITY_ACTIVE: makeAPI(Method.PUT, 'activities/{id}')(),
    DEL_ACTIVITY: makeAPI(Method.DELETE, 'activities/{id}')(),
    GET_ACTIVITY_LAYOUT: makeAPI(Method.GET, 'activity/layout')(),
    POST_ACTIVITY_LAYOUT: makeAPI(Method.POST, 'activity/layout')(),
    PUT_ACTIVITY_LAYOUT: makeAPI(Method.PUT, 'activity/layout')(),
    GET_ACTIVITY_BANNER: makeAPI(Method.GET, 'activity/banner')(),
    POST_ACTIVITY_BANNER: makeAPI(Method.POST, 'activity/banner')(),
    PUT_ACTIVITY_BANNER: makeAPI(Method.PUT, 'activity/banner')(),
    // 系統活動
    GET_ACTIVITY_NEW_MEMBER_BONUS: makeAPI(Method.GET, 'activity/new-member-bonus')(),
    PUT_ACTIVITY_NEW_MEMBER_BONUS: makeAPI(Method.PUT, 'activity/new-member-bonus')(),
    GET_ACTIVITY_RECOMMEND_FRIEND: makeAPI(Method.GET, 'activity/recommend-friend')(),
    PUT_ACTIVITY_RECOMMEND_FRIEND: makeAPI(Method.PUT, 'activity/recommend-friend')(),
    GET_ACTIVITY_INVITE_FRIEND: makeAPI(Method.GET, 'activity/invite-friend')(),
    PUT_ACTIVITY_INVITE_FRIEND: makeAPI(Method.PUT, 'activity/invite-friend')(),
    GET_ACTIVITY_DAILY_SIGN_IN_BONUS: makeAPI(Method.GET, 'activity/daily-sign-in-bonus')(),
    PUT_ACTIVITY_DAILY_SIGN_IN_BONUS: makeAPI(Method.PUT, 'activity/daily-sign-in-bonus')(),
    GET_ACTIVITY_WEEKLY_BONUS: makeAPI(Method.GET, 'activity/weekly-bonus')(),
    PUT_ACTIVITY_WEEKLY_BONUS: makeAPI(Method.PUT, 'activity/weekly-bonus')(),
    GET_ACTIVITY_FEEDBACK_BONUS: makeAPI(Method.GET, 'activity/feedback-bonus')(),
    PUT_ACTIVITY_FEEDBACK_BONUS: makeAPI(Method.PUT, 'activity/feedback-bonus')(),
    GET_ACTIVITY_FEEDBACK_EXTRA_BONUS: makeAPI(Method.GET, 'activity/feedback-extra-bonus')(),
    PUT_ACTIVITY_FEEDBACK_EXTRA_BONUS: makeAPI(Method.PUT, 'activity/feedback-extra-bonus')(),
    GET_ACTIVITY_RANK_BONUS: makeAPI(Method.GET, 'activity/rank-bonus')(),
    PUT_ACTIVITY_RANK_BONUS: makeAPI(Method.PUT, 'activity/rank-bonus')(),
    GET_ACTIVITY_NEW_YEAR_2023: makeAPI(Method.GET, 'activity/new-year-2023')(),
    PUT_ACTIVITY_NEW_YEAR_2023: makeAPI(Method.PUT, 'activity/new-year-2023')(),
    GET_ACTIVITY_DRAGON_BOAT_FESTIVAL_2023: makeAPI(Method.GET, 'activity/dragon-boat-festival-2023')(),
    PUT_ACTIVITY_DRAGON_BOAT_FESTIVAL_2023: makeAPI(Method.PUT, 'activity/dragon-boat-festival-2023')(),
    GET_ACTIVITY_NEW_YEAR_2024: makeAPI(Method.GET, 'activity/new-year-2024')(),
    PUT_ACTIVITY_NEW_YEAR_2024: makeAPI(Method.PUT, 'activity/new-year-2024')(),
    GET_ACTIVITY_NEW_YEAR_2025: makeAPI(Method.GET, 'activity/snake-year-good-luck')(),
    PUT_ACTIVITY_NEW_YEAR_2025: makeAPI(Method.PUT, 'activity/snake-year-good-luck')(),
    GET_ACTIVITY_NEW_YEAR_2026: makeAPI(Method.GET, 'activity/new-year-2026')(),
    PUT_ACTIVITY_NEW_YEAR_2026: makeAPI(Method.PUT, 'activity/new-year-2026')(),
    GET_ACTIVITY_DEPOSIT_BONUS: makeAPI(Method.GET, 'activity/deposit-bonus-2024')(),
    PUT_ACTIVITY_DEPOSIT_BONUS: makeAPI(Method.PUT, 'activity/deposit-bonus-2024')(),
    GET_ACTIVITY_UEFA_BUILDING_UP: makeAPI(Method.GET, 'activity/uefa-building-up')(),
    PUT_ACTIVITY_UEFA_BUILDING_UP: makeAPI(Method.PUT, 'activity/uefa-building-up')(),
    GET_ACTIVITY_UEFA_STARS: makeAPI(Method.GET, 'activity/uefa-stars')(),
    PUT_ACTIVITY_UEFA_STARS: makeAPI(Method.PUT, 'activity/uefa-stars')(),
    GET_ACTIVITY_WEEKLY_BONUS_DRAW: makeAPI(Method.GET, 'activity/weekly-bonus-draw')(),
    PUT_ACTIVITY_WEEKLY_BONUS_DRAW: makeAPI(Method.PUT, 'activity/weekly-bonus-draw')(),
    GET_ACTIVITY_DAILY_BONUS_DRAW: makeAPI(Method.GET, 'activity/daily-bonus-draw')(),
    PUT_ACTIVITY_DAILY_BONUS_DRAW: makeAPI(Method.PUT, 'activity/daily-bonus-draw')(),
    POST_IMAGE: makeAPI(Method.POST, '/images')(),
    GET_ACTIVITY_RECORD_NEW_MEMBER_BONUS: makeAPI(Method.GET, 'company-report/activity-report/new-member-bonus')(),
    GET_ACTIVITY_RECORD_RECOMMEND_FRIEND: makeAPI(Method.GET, 'company-report/activity-report/recommend-friends')(),
    GET_ACTIVITY_RECORD_INVITE_FRIEND: makeAPI(Method.GET, 'company-report/activity-report/invite-friends')(),
    GET_ACTIVITY_RECORD_INVITE_FRIEND_RELATIONS: makeAPI(Method.GET, 'company-report/activity-report/invite-friends/{userAccount}/relations')(),
    GET_ACTIVITY_RECORD_UPGRADE_BONUS: makeAPI(Method.GET, 'company-report/activity-report/upgrade-bonus')(),
    GET_ACTIVITY_RECORD_DAILY_SIGN_IN: makeAPI(Method.GET, 'company-report/activity-report/daily-sign-in')(),
    GET_ACTIVITY_RECORD_WEEKLY_BONUS: makeAPI(Method.GET, 'company-report/activity-report/weekly-bonus')(),
    GET_ACTIVITY_RECORD_BIRTHDAY_BONUS: makeAPI(Method.GET, 'company-report/activity-report/birthday-bonus')(),
    GET_ACTIVITY_APPLICATIONS: makeAPI(Method.GET, 'activity/layout/applications')(),
    POST_ACTIVITY_LOCK_APPLICATIONS: makeAPI(Method.POST, 'activity/layout/lock-applications')(),
    PUT_ACTIVITY_APPLICATION: makeAPI(Method.PUT, 'activity/layout/applications')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_2023: makeAPI(Method.GET, 'company-report/activity-report/new-year-2023')(),
    GET_ACTIVITY_RECORD_DRAGON_BOAT_FESTIVAL_2023: makeAPI(Method.GET, 'company-report/activity-report/dragon-boat-festival-2023')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_2024: makeAPI(Method.GET, 'company-report/activity-report/new-year-2024')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_2025_RED_ENVELOPE: makeAPI(Method.GET, 'company-report/activity-report/snake-year-good-luck-red-envelope')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW: makeAPI(Method.GET, 'company-report/activity-report/snake-year-good-luck-draw')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW_TICKET: makeAPI(Method.GET, 'company-report/activity-report/snake-year-good-luck-draw/ticket')(),
    POST_ACTIVITY_RECORD_NEW_YEAR_2025_DRAW_TICKET: makeAPI(Method.POST, 'company-report/activity-report/snake-year-good-luck-draw/ticket')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_TICKET: makeAPI(Method.GET, 'company-report/activity-report/new-year/ticket')(),
    POST_ACTIVITY_RECORD_NEW_YEAR_TICKET: makeAPI(Method.POST, 'company-report/activity-report/new-year/ticket')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_TICKET_USER_INFO: makeAPI(Method.GET, 'company-report/activity-report/new-year/ticket/user-info')(),
    GET_ACTIVITY_RECORD_NEW_YEAR_RED_ENVELOPE: makeAPI(Method.GET, 'company-report/activity-report/new-year/red-envelope')(),
    GET_ACTIVITY_RECORD_DEPOSIT_BONUS: makeAPI(Method.GET, 'company-report/activity-report/deposit-bonus-2024')(),
    GET_ACTIVITY_RECORD_UEFA_BUILDING_UP: makeAPI(Method.GET, 'company-report/activity-report/uefa-building-up')(),
    GET_ACTIVITY_RECORD_UEFA_STARS: makeAPI(Method.GET, 'company-report/activity-report/uefa-stars')(),
    GET_ACTIVITY_RECORD_UEFA_STARS_TICKET: makeAPI(Method.GET, 'company-report/activity-report/uefa-stars/ticket')(),
    POST_ACTIVITY_RECORD_UEFA_STARS_TICKET: makeAPI(Method.POST, 'company-report/activity-report/uefa-stars/ticket')(),
    GET_ACTIVITY_RECORD_WEEKLY_BONUS_DRAW: makeAPI(Method.GET, 'company-report/activity-report/weekly-bonus-draw')(),
    GET_ACTIVITY_RECORD_DAILY_BONUS_DRAW: makeAPI(Method.GET, 'company-report/activity-report/daily-bonus-draw')()
};
const HISTORY_API = {
    GET_BET_HISTORY: makeAPI(Method.POST, 'player-report/bet-history')(),
    GET_TRANSFER_HISTORY: makeAPI(Method.GET, 'player-report/transfer-history')(),
    GET_TRANSFER_HISTORY_EXCEPTION: makeAPI(Method.GET, 'player-report/transfer-history/{id}/exception')(),
    POST_CHECK_TRANSFER: makeAPI(Method.POST, 'wallets/check-transfer')(),
    POST_TRANSFER_HISTORY_CONFIRM: makeAPI(Method.POST, 'player-report/transfer-history/{id}/confirm')(),
    POST_TRANSFER_HISTORY_CANCEL: makeAPI(Method.POST, 'player-report/transfer-history/{id}/cancel')(),
    GET_OPERATION_HISTORY: makeAPI(Method.GET, 'journal/operation-history')(),
    GET_IP_HITSOTRY: makeAPI(Method.GET, 'login-history')(),
    GET_GAME_LOGIN_HISTORY: makeAPI(Method.GET, 'game/login/history')(),
    GET_GAME_LOGIN_HISTORY_DETAIL: makeAPI(Method.GET, 'game/login/history/{id}')(),
    GET_ADMIN_LOGIN_HISTORY: makeAPI(Method.GET, 'login-history/admin')(),
    GET_AGENT_LOGIN_HISTORY: makeAPI(Method.GET, 'login-history/agent')(),
    GET_IP_MONITORING_HISTORY: makeAPI(Method.GET, 'players/ip')(),
    GET_PLAYER_PROFIT_HISTORY: makeAPI(Method.POST, 'player-report/revenue')(),
    POST_PLAYER_REPORT_REVENUE_CHECK_CSV: makeAPI(Method.POST, 'player-report/revenue/check-csv')(),
    GET_PROFIT_HISTORY_TEAM: makeAPI(Method.GET, 'team-revenue/team')(),
    GET_PROFIT_HISTORY_GAMES: makeAPI(Method.GET, 'team-revenue/games')(),
    GET_PROFIT_HISTORY_AGENTS: makeAPI(Method.GET, 'team-revenue/agents')(),
    GET_PROFIT_HISTORY_FINANCE_FEE_GOLDEN_DETAILS: makeAPI(Method.GET, 'team-revenue/finance-fee-details/agents/golden')(),
    GET_PROFIT_HISTORY_FINANCE_FEE_AGENTS_DETAILS: makeAPI(Method.GET, 'team-revenue/finance-fee-details/agents/{agent_id}')(),
    GET_PROFIT_HISTORY_FINANCE_FEE_PLAYERS_DETAILS: makeAPI(Method.GET, 'team-revenue/finance-fee-details/players/{user_id}')(),
    GET_PROFIT_GOLDEN_INFO: makeAPI(Method.GET, 'team-revenue/agents/golden')(),
    GET_PROFIT_GOLDEN_INFO_CHILDREN: makeAPI(Method.GET, 'team-revenue/agents/golden/children')(),
    GET_PROFIT_LAYER_INFO: makeAPI(Method.GET, 'team-revenue/agents/{id}')(),
    GET_PROFIT_LAYER_INFO_CHILDREN: makeAPI(Method.GET, 'team-revenue/agents/{id}/children')(),
    GET_DEPOSIT_STATISTIC: makeAPI(Method.GET, 'deposit-statistics')(),
    GET_DEPOSIT_STATISTIC_DETAIL: makeAPI(Method.GET, 'deposit-statistics/detail')(),
    GET_NEW_PLAYER_STATISTIC: makeAPI(Method.GET, 'company-report/newcomer')(),
    GET_CASH_LOG: makeAPI(Method.GET, 'player-report/cash-log')(),
    GET_CASH_ACCOUNTING_USER_STATISTIC: makeAPI(Method.POST, 'player-report/cash-accounting/user-statistic')(),
    GET_CASH_ACCOUNTING_BET_HISTORY_STATISTIC: makeAPI(Method.POST, 'player-report/cash-accounting/bet-history-statistic')(),
    GET_IN_AND_OUT_PLATFORM: makeAPI(Method.GET, 'company-report/platform-statistics')(),
    GET_IN_AND_OUT_REVENUE: makeAPI(Method.GET, 'company-report/revenue-statistics')(),
    GET_IN_AND_OUT_DEPOSIT_AND_WITHDRAW: makeAPI(Method.GET, 'company-report/transaction-statistics')(),
    GET_IN_AND_OUT_TRANSFER: makeAPI(Method.GET, 'company-report/transfer-statistics')(),
    GET_PLATFORM_FEE_DAILY_RECORDS: makeAPI(Method.GET, 'platform-fee-daily-records')(),
    GET_AGENT_OPERATION_LOG: makeAPI(Method.GET, 'agents/operation-history')(),
    GET_LEADERBOARD_ALL: makeAPI(Method.GET, 'company-report/leaderboard/all')(),
    GET_LEADERBOARD_CATEGORIES: makeAPI(Method.GET, 'company-report/leaderboard/categories')(),
    GET_LEADERBOARD_DETAIL_ALL: makeAPI(Method.GET, 'company-report/leaderboard/detail/all')(),
    GET_LEADERBOARD_DETAIL_CATEGORIES: makeAPI(Method.GET, 'company-report/leaderboard/detail/categories')(),
    GET_REVENUE_SNAPSHOT: makeAPI(Method.GET, 'company-report/revenue-snapshot')(),
    GET_REVENUE_TREND: makeAPI(Method.GET, 'company-report/revenue-trend')(),
    GET_FEEDBACK_HISTORY: makeAPI(Method.GET, 'player-report/feedback')(),
    GET_PLAYER_REPORT_WINLOSS_ANALYZE: makeAPI(Method.GET, 'player-report/winlost-analyze')(),
    GET_USER_WALLET_LOCKS: makeAPI(Method.GET, 'user-wallet-locks')()
};
const EXPORT_API = {
    POST_EXPORT_BET_HISTORY_VALIDATE: makeAPI(Method.POST, 'export/bet-history/validate')(),
    GET_EXPORT_MANUAL_DEPOSIT_VALIDATE: makeAPI(Method.GET, 'export/manual-deposit/validate')(),
    GET_EXPORT_MANUAL_WITHDRAW_VALIDATE: makeAPI(Method.GET, 'export/manual-withdraw/validate')(),
    GET_EXPORT_ACTIVITY_APPLICATIONS: makeAPI(Method.GET, 'export/activity/layout/applications/validate')(),
    GET_EXPORT_WITHDRAW_SLIP_VALIDATE: makeAPI(Method.GET, 'export/withdraw/validate')(),
    POST_EXPORT_PLAYER_REVENUE_VALIDATE: makeAPI(Method.POST, 'export/player-revenue/validate')(),
    GET_EXPORT_WITHDRAW_RC_VALIDATE: makeAPI(Method.GET, 'export/withdraw-manage/rc/validate')(),
    GET_EXPORT_GASH_LOG: makeAPI(Method.GET, 'export/gash-logs')(),
    GET_EXPORT_ACTIVITY_WALLET_VALIDATE: makeAPI(Method.GET, 'export/activity-wallet/validate')(),
    GET_EXPORT_ACTIVITY_WALLET: makeAPI(Method.GET, 'export/activity-wallet')()
};
const DOWNLOAD_LINK_API = {
    GET_DOWNLOAD_LINK: makeAPI(Method.GET, 'forwarder-download-links')(),
    POST_DOWNLOAD_LINK: makeAPI(Method.POST, 'forwarder-download-links')()
};
const JOINT_VENTURE_API = {
    GET_JOINT_VENTURE_SETTING: makeAPI(Method.GET, 'joint-venture')(),
    POST_JOINT_VENTURE_SETTING: makeAPI(Method.POST, 'joint-venture')()
};
const FEATURE_FLAG_API = {
    GET_PLAYER_FEATURE_FLAG: makeAPI(Method.GET, 'feature-flag/user/{id}')(),
    PATCH_PLAYER_FEATURE_FLAG: makeAPI(Method.PATCH, 'feature-flag/user/{id}')()
};
const AGENT_MEMO_API = {
    GET_AGENT_MEMO_LIST: makeAPI(Method.GET, 'agent-memos')(),
    POST_AGENT_MEMO: makeAPI(Method.POST, 'agent-memos')(),
    POST_VALIDATE_AGENT_MEMO_EXSIT: makeAPI(Method.POST, 'agent-memos/exists')(),
    GET_AGENT_MEMO: makeAPI(Method.GET, 'agent-memos/{id}')(),
    UPDATE_AGENT_MEMO: makeAPI(Method.PUT, 'agent-memos/{id}')(),
    DELETE_AGENT_MEMO: makeAPI(Method.DELETE, 'agent-memos/{id}')()
};
const GASH_API = {
    GET_GASH_LOGS: makeAPI(Method.GET, 'gash-logs')(),
    GET_GASH_USER_INFO: makeAPI(Method.GET, 'gash/user-info')(),
    POST_GASH_RECLAIM: makeAPI(Method.POST, 'gash/reclaim')(),
    POST_GASH_GRANT: makeAPI(Method.POST, 'gash/grant')()
};
export const ADMIN_API = {
    ...AUTH_API,
    ...ME_API,
    ...ADMIN_ACCOUNT_API,
    ...ANNOUNCEMENT_API,
    ...NOTIFICATION_API,
    ...SMS_API,
    ...ROLE_API,
    ...EMPEROR_API,
    ...AGENT_WALLETS_API,
    ...STAFF_API,
    ...JUMP_SHIP_API,
    ...PLAYER_API,
    ...FINANCE_API,
    ...DEPOSIT_API,
    ...WITHDRAW_API,
    ...MANUAL_API,
    ...PARAMETER_API,
    ...PLATFORM_API,
    ...GREETING_API,
    ...ALERT_API,
    ...ACTIVITY_API,
    ...HISTORY_API,
    ...EXPORT_API,
    ...DOWNLOAD_LINK_API,
    ...JOINT_VENTURE_API,
    ...FEATURE_FLAG_API,
    ...AGENT_MEMO_API,
    ...GASH_API
};
//# sourceMappingURL=AdminAPI.js.map